import React, { useEffect, useState } from "react";
import {
  $accounts,
  $selectedAccountIdx,
  AccountsDoneLoading,
  AddChargesToAccount,
  AddOwnerTypeToAccount,
  IAccount,
  queryAccounts,
  updateAccount,
} from "../../../common/accounts2";
import { AccountListItem } from "../molecules/AccountListItem";
import { AccountTotalBlock } from "../molecules/AccountTotalBlock";
import { AccountsLoading } from "./../atoms/AccountsLoading";
import { AccountsBlockTitle } from "./../atoms/AccountsBlockTitle";
import { AccountKapRemontTotalBlock } from "../molecules/AccountKapRemontTotalBlock";
import { queryCompanies } from "../../../common/companies2";
import { useStore } from "effector-react";
import "../styles/Accounts.css";
import { getCustomUserAgent, getCustomUserAgentKrk } from "../../../common/customUserAgent";
import { SetAccountAccess2slave } from "../molecules/SetAccountAccess2slave";
import { AccountTransactions } from "../molecules/AccountTransactions";
import { queryUser } from "../../../common/user";
import { empty } from "../../../common/functions";
interface IAccountBlock {
  setLookButtonIsClicked: React.Dispatch<React.SetStateAction<boolean>>;
  searchParams: object
  loading: boolean
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
}

export const AccountsBlock = ({ setLookButtonIsClicked, searchParams, loading, setLoading }: IAccountBlock) => {
  const [accsShown, setAccsShown] = useState<boolean>(false); //состояние, указывающее на то, показываться ли список аакаунтов полностью
  const [sameAcc, setSameAcc] = useState<IAccount | null>(null);
  const accIdx = useStore($selectedAccountIdx); //индекс текущего аккаунта
  // const [loading, setLoading] = useState<boolean>(false)

  const { loaded, fail, failMsg, accounts } = useStore($accounts);

  const getAddrOrOwnerFIO = (acc: IAccount) => {
    return getCustomUserAgent() == getCustomUserAgentKrk() ? acc.ownerFio : acc.address
  }

  // классы для скрытия\показа полного списка ЛС
  let hiddenContainerClassName = accsShown
    ? "data-card__account-list"
    : "data-card__account-list data-card__account-list_hidden";
  //Данный эффект выполниться только после первой отрисовки элемента
  useEffect(() => {
    if (accounts.length === 0) {
      setLoading(true)
      queryAccounts()
        .then(async res => {
          var bar = new Promise((resolve, reject) => {
            if (res.accounts.length === 0) { resolve("@"); return } // нет ЛС — сразу завершаем
            res.accounts.forEach(async (elem, index) => {
              await updateAccount({ account: elem, accounts: res.accounts });
              // начисления (charge/periods) грузим не по всем ЛС, а только для выбранного — см. эффект ниже
              if (getCustomUserAgent() === getCustomUserAgentKrk()
                // ||getCustomUserAgent() === getCustomUserAgentASB()
              ) {
                await AddOwnerTypeToAccount({ account: elem, accounts: res.accounts })
              }
              if (index === res.accounts.length - 1) resolve("@");
            })
          })
          await bar // ждём завершения обогащения аккаунтов, только потом снимаем загрузку
          setLoading(false);
          AccountsDoneLoading()
        })
        .catch(() => {
          setLoading(false);
          AccountsDoneLoading()
        })
      // res.accounts.forEach(elem => {
      //   updateAccount({ account: elem, accounts: res.accounts });
      //   AddChargesToAccount({ account: elem, accounts: res.accounts })
      //   AddOwnerTypeToAccount({ account: elem, accounts: res.accounts })
      // },
      //   setLoading(false)
      // ))
      // .then(()=>setLoading(false))
      //запрашиваем аккаунты
      queryCompanies(); // запрашиваем компании
    }
    if (accIdx > -1 && accounts.length > 1)
      setSameAcc(
        accounts.find((account) => account.id === accounts[accIdx].id) || null
      );

  }, [accIdx]);
  useEffect(() => {
    if (accIdx > -1 && accounts.length > 1)
      setSameAcc(
        accounts.find((account) => account.id === accounts[accIdx].id) || null
      );
  }, [accounts])
  useEffect(() => {
    queryUser()
  }, [])

  // Начисления грузим только для выбранного ЛС
  useEffect(() => {
    if (accIdx > -1 && accounts.length > accIdx) {
      const acc = accounts[accIdx]
      if (empty(acc.totalByMonth)) AddChargesToAccount({ account: acc, accounts })
    }
  }, [accIdx, accounts])

  return (
    <div className="page__data-card">
      <SetAccountAccess2slave searchParams={searchParams} />
      {!loaded || loading ? (
        <AccountsLoading />
      ) : fail ? (
        <p className="data-card__text">{failMsg}</p>
      ) : accIdx < 0 || accounts.length === 0 ? (
        <p className="data-card__text">Нет подключенных аккаунтов</p>
      ) : (
        <>
          <div className="data-card__header data-card__header_number">
            <AccountsBlockTitle
              accountNum={accounts[accIdx].externalAccountNum}
              accsShown={accsShown}
              setAccsShown={setAccsShown}
              accountsCount={accounts.length}
              addressOrOwnerFIO={getAddrOrOwnerFIO(accounts[accIdx])}
            />
            {accounts.length > 1 && sameAcc && (
              <ul className={hiddenContainerClassName}>
                {accounts.map((account, i) => (
                  <AccountListItem
                    key={i}
                    setAccShown={setAccsShown}
                    accountIdx={i}
                    accountId={account.id}
                    accountNum={account.externalAccountNum}
                    addressOrOwnerFIO={getAddrOrOwnerFIO(account)}
                    companyId={account.companyId}
                    sameAcc={sameAcc.id}
                  />
                ))}
              </ul>
            )}
          </div>

          <AccountTotalBlock
            account={accounts[accIdx]}
            setLookButtonIsClicked={setLookButtonIsClicked}
          />
          <AccountKapRemontTotalBlock account={accounts[accIdx]} />
          <AccountTransactions accountId={accounts[accIdx].id} ></AccountTransactions>
        </>
      )}
    </div>
  );
};
